import { authGet, authPost } from "../http_client.js";
import type {
  RoyalWheelCollectResponseDto,
  RoyalWheelPayloadDto,
  RoyalWheelSpinResponseDto,
} from "../dto/royal_wheel.dto.js";

export function getRoyalWheel(): Promise<RoyalWheelPayloadDto>
{
  return authGet<RoyalWheelPayloadDto>( "api/player/me/royal-wheel" );
}

export function spinRoyalWheel( request_id: string ): Promise<RoyalWheelSpinResponseDto>
{
  return authPost<RoyalWheelSpinResponseDto>( "api/player/me/royal-wheel/spin", { request_id } );
}

export function collectRoyalWheel(): Promise<RoyalWheelCollectResponseDto>
{
  return authPost<RoyalWheelCollectResponseDto>( "api/player/me/royal-wheel/collect", {} );
}

export function debugAddRoyalWheelTokens( add: number ): Promise<{ tokens: number }>
{
  return authPost<{ tokens: number }>( "api/player/me/royal-wheel/debug/tokens", { add } );
}

export function debugResetRoyalWheel(): Promise<{ deleted: boolean }>
{
  return authPost<{ deleted: boolean }>( "api/player/me/royal-wheel/debug/reset", {} );
}
